var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 115,
    viewBox: "0 0 115 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21_50)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.9564 69.9171L47.1345 93.5749C49.1527 91.7076 49.1824 91.2224 51.1115 89.5462C53.0555 87.3554 54.3466 86.2526 56.5725 83.6648C58.7985 81.077 60.4753 78.2392 61.2767 75.5632C62.078 72.8872 61.7812 71.9756 61.3064 70.0641C60.8315 68.1527 59.8521 66.7117 58.472 65.903C57.0771 65.0943 55.326 64.9473 53.3968 65.4472C51.5567 66.0795 50.9038 66.3294 48.9449 68.0203C48.0842 68.8731 47.9507 69.0349 46.9564 69.9171ZM42.1484 13.0882C44.0479 13.0147 44.9234 13.1617 46.8229 13.0147C46.8971 15.0438 46.8674 64.962 46.8229 64.9767C50.1173 62.7418 49.776 62.7124 53.0704 61.4773C56.3499 60.2422 59.585 59.757 62.449 60.1099C65.2982 60.448 67.6726 61.5949 69.3346 63.4328C70.9966 65.2708 72.9555 67.9321 72.9703 70.7699C72.9852 73.6076 71.516 77.1953 69.4533 79.5919C66.6338 82.8561 63.3097 85.4292 59.4662 88.0758C55.6821 90.6783 52.1503 93.3544 49.3308 95.854C46.6003 98.0595 45.2944 99.2946 42.2226 101.971C42.1484 99.5004 42 96.7509 42.0148 94.81L42.1484 13.0882Z",
    fill: "#40514E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.9564 69.9171L47.1345 93.5749C49.1527 91.7076 49.1824 91.2224 51.1115 89.5462C53.0555 87.3554 54.3466 86.2526 56.5725 83.6648C58.7984 81.077 60.4753 78.2392 61.2767 75.5632C62.078 72.8872 61.7812 71.9755 61.3063 70.0641C60.8315 68.1527 59.8521 66.7117 58.472 65.903C57.0771 65.0943 55.326 64.9473 53.3968 65.4472C51.5567 66.0795 50.9038 66.3294 48.9449 68.0203C48.0842 68.8731 47.9507 69.0349 46.9564 69.9171Z",
    stroke: "#40514E",
    strokeWidth: 1.06666,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.1484 13.0882C44.0479 13.0147 44.9234 13.1617 46.8229 13.0147C46.8971 15.0438 46.8674 64.962 46.8229 64.9767C50.1173 62.7418 49.776 62.7124 53.0704 61.4773C56.3499 60.2422 59.585 59.757 62.449 60.1099C65.2982 60.448 67.6726 61.5949 69.3346 63.4328C70.9966 65.2708 72.9555 67.9321 72.9703 70.7699C72.9852 73.6076 71.516 77.1953 69.4533 79.5919C66.6338 82.8561 63.3097 85.4292 59.4662 88.0758C55.6821 90.6783 52.1503 93.3544 49.3308 95.854C46.6003 98.0595 45.2944 99.2946 42.2226 101.971C42.1484 99.5004 42 96.7509 42.0148 94.81L42.1484 13.0882Z",
    stroke: "#40514E",
    strokeWidth: 1.06666,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_50"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 89,
    fill: "white",
    transform: "translate(42 13)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlat);
export default __webpack_public_path__ + "static/media/flat.6331408e4e82a9be3785a09a1b6d3906.svg";
export { ForwardRef as ReactComponent };